export const initialState = {
  AdvertisementList: [],
  AdvertisementPage: {}
};
